import {
  Action,
  ActionSubject,
  type FeatureEvents,
  type FeatureEventUi,
  type OperationalEvent,
  type ScreenEvent,
  type TrackEvent,
  type UIEvent,
} from '../new-analytics-types';

type ScreenKeys = 'jsmGracePeriodPopUpScreenEvent';

type UiEventKeys = 'tryPremiumForFreeButtonClick' | 'moreDetailsButtonClick' | 'toggleJsmGracePeriodPopUp';

// Screens
export const jsmGracePeriodPopUpScreen = 'jsmGracePeriodPopUpScreen';

export const withMigrationAttribute = (fn: (attributes: Record<string, any>) => any) => (attributes: Record<string, any>) => {
  const newAttributes = { ...attributes, migration: true };

  return fn(newAttributes);
};

export type FeatureEventsScreenType = Record<ScreenKeys, (attributes?: Record<string, any>) => ScreenEvent>;
export type FeatureEventsUIType = Record<UiEventKeys, FeatureEventUi>;
export type FeatureEventsTrackType = Record<string, (attributes?: Record<string, any>) => TrackEvent>;
export type FeatureEventsOperationalType = Record<string, (attributes?: Record<string, any>) => OperationalEvent>;

export const mapEventsWithMigrationAttribute = <T extends Record<string, (attributes: Record<string, any>) => any>>(events: T): T =>
  Object.fromEntries(Object.entries(events).map(([key, eventFn]) => [key, withMigrationAttribute(eventFn)])) as T;

export const jsmGracePeriodPopUpEvents: FeatureEvents<ScreenKeys, UiEventKeys, string, string> = {
  confluenceSpec: 'https://hello.atlassian.net/wiki/spaces/ITSOL/pages/5841492223/T-7+Admin+Hub+Warning+Icons',
  screen: mapEventsWithMigrationAttribute<FeatureEventsScreenType>({
    jsmGracePeriodPopUpScreenEvent: (attributes): ScreenEvent => ({
      data: {
        name: jsmGracePeriodPopUpScreen,
        attributes,
      },
      dataPortalLink: 'https://data-portal.internal.atlassian.com/analytics/registry/89161',
    }),
  }),
  ui: mapEventsWithMigrationAttribute<FeatureEventsUIType>({
    toggleJsmGracePeriodPopUp: (attributes: { cloudId: string; page: string; isOpen: boolean }): UIEvent => ({
      data: {
        action: Action.Clicked,
        actionSubject: ActionSubject.Button,
        actionSubjectId: 'toggleJsmGracePeriodPopUp',
        source: jsmGracePeriodPopUpScreen,
        attributes,
      },
      dataPortalLink: 'https://data-portal.internal.atlassian.com/analytics/registry/89165',
    }),
    tryPremiumForFreeButtonClick: (attributes: { cloudId: string; page: string }): UIEvent => ({
      data: {
        action: Action.Clicked,
        actionSubject: ActionSubject.Button,
        actionSubjectId: 'tryPremiumForFreeButton',
        source: jsmGracePeriodPopUpScreen,
        attributes,
      },
      dataPortalLink: 'https://data-portal.internal.atlassian.com/analytics/registry/86696',
    }),
    moreDetailsButtonClick: (attributes: { cloudId: string; page: string }): UIEvent => ({
      data: {
        action: Action.Clicked,
        actionSubject: ActionSubject.Button,
        actionSubjectId: 'moreDetailsButton',
        source: jsmGracePeriodPopUpScreen,
        attributes,
      },
      dataPortalLink: 'https://data-portal.internal.atlassian.com/analytics/registry/89166',
    }),
  }),
  track: mapEventsWithMigrationAttribute<FeatureEventsTrackType>({}),
  operational: mapEventsWithMigrationAttribute<FeatureEventsOperationalType>({}),
};
